import styled from 'styled-components';

const Container = styled.div`
	margin: 8px 0 0 0;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-items: start;
	align-items: center;
`;

const Item = styled.div`
	width: calc(50% - 16px);
	margin: 0 8px 16px 8px;
	position: relative;
	background-repeat: no-repeat;
	background-size: cover;
	box-shadow:
		0px 4px 8px -2px ${props => props.active ? props.theme.mainOpacity(100) : 'rgba(0,0,0,0)'},
		0px 0px 0px ${props => props.active ? 2 : 0}px #4A90E2;
	transform: translateY(0px);
	transition: all 0.3s ease-out;
	cursor: pointer;
	justify-self: center;

	&:hover {
		transform: translateY(${props => props.active ? 0 : -4}px);
		box-shadow:
			0px ${props => props.active ? '4px 8px' : '8px 16px'} -2px ${props => props.active ? props.theme.mainOpacity(100) : 'rgba(0,0,0,0.2)'},
			0px 0px 0px 2px #4A90E2;
	}
`;

const TooltipWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	align-items: flex-end;
	justify-content: flex-end;
	padding: 8px;
	display: ${props => props.active ? 'flex' : 'none'};
`;

const Button = styled.button`
	justify-self: center;
	align-self: center;
	border: 1px solid #4A90E2;
	color: #4A90E2;
	background: white;
	margin: 1rem 0 0 0;
	width: 100%;
	padding: 8px 16px;
	border-radius: 4px;
	font-size: 14px;
	cursor: pointer;
	box-shadow: 0px 0px 0px -2px #4A90E2;
	transition: all 0.3s ease-out;

	&:hover {
		box-shadow: 0px 2px 16px -4px rgba(74,144,226,0.6);
	}
`;

export {
	Container,
	Item,
	TooltipWrapper,
	Button,
}
